import { useState, useEffect } from 'react';
import CommonCreate from '@/components/common/Create';
import RefuelingForm from '../forms/RefuelingForm';
import { mergeDateAndTime } from '@/utils/formChange';
import axiosInstance from '@/utils/axiosInstance';

const RefuelingCreate = () => {
    const [formProp, setFormProp] = useState({
        date: new Date(),
        time: "",
        vehicle_id: "",
        odometer: 0,
        type: "primary",
        notes: "",
    });
    const [otherData, setOtherData] = useState({
        price_primary: '',
        liters_primary: '',
        price_secondary: '',
        liters_secondary: '',
    });
    const [selectedVehicleOptions, setSelectedVehicleOptions] = useState<any>({ two_tanks: false, fuel_id: 0 });

    useEffect(() => {
        const unsub = async () => {
            if (formProp.vehicle_id) {
                const response = await axiosInstance.get(`/vehicles/${formProp.vehicle_id}`)
                setSelectedVehicleOptions({ two_tanks: response.data.two_tanks, fuel_id: response.data.vehicle_tanks[0]?.fuel_id || 0 });
            }
        };
        unsub();
    }, [formProp.vehicle_id]);

    return (
        <CommonCreate title='Create Refueling' resource='refueling' data={{
            data: {
                odometer: formProp.odometer,
                notes: formProp.notes,
                date: mergeDateAndTime(formProp.date, formProp.time),
                vehicle_id: +formProp.vehicle_id,
                two_tanks: selectedVehicleOptions?.two_tanks || false,
                missed_previous_refueling: false,
            },
            tanks: [
                formProp.type !== "primary" && {
                    fuel_id: selectedVehicleOptions?.fuel_id || 0,
                    unit_value: +otherData.liters_secondary,
                    price: +otherData.price_secondary / +otherData.liters_secondary,
                    total_cost: +otherData.price_secondary,
                    are_you_filling_tank: false,
                    type: "SECONDARY",
                },
                formProp.type !== "secondary" && {
                    fuel_id: selectedVehicleOptions?.fuel_id || 0,
                    unit_value: +otherData.liters_primary,
                    price: +otherData.price_primary / +otherData.liters_primary,
                    total_cost: +otherData.price_primary,
                    are_you_filling_tank: false,
                    type: "PRIMARY",
                }
            ].filter(Boolean)
        }}>
            <RefuelingForm mode='create' formProp={formProp} setFormProp={setFormProp} otherData={otherData} setOtherData={setOtherData} />
        </CommonCreate>
    );
};

export default RefuelingCreate;
